export enum EUserAccessPart {
  // User Management
  InviteUser = "design_approval_requester",
  DesignApprovalReviewer = "design_approval_reviewer",
  DeleteUserInvitation = "design_approval_deleter",
  DeleteUser = "delete_user",
  AddEditRole = "add_edit_role",
  DeleteRole = "delete_role",
  AddEditUser = "add_edit_user",
  // ListUsers = "list_users",
  // DisableUser = "disable_user",
  // EnableUser = "enable_user",

  // Subscription Management
  EditSubscription = "add_edit_subscription",
  UpdateCreditCard = "add_edit_credit_card",
  ChooseSubscriptionPlan = "choose_subscription_plan",
  SubscriptionManagement = "edit_subscription_plan",
  ViewSubscriptionInvoices = "view_subscription_invoices",

  // Project Management
  // FullAccessAllProjects = "full_access_all_projects",
  CreateProject = "create_project",
  TransferProjectOwnership = "transfer_project_ownership",
  ViewProject = "view_project",
  EditProjectRole = "edit_project_role",
  DeleteProject = "delete_project",
  EditProject = "edit_project",
  RenameProject = "rename_project",
  UpdateProjectIcon = "update_project_icon",
  ChangeDesignGuide = "change_design_guide",
  ChangeProjectVisibility = "change_project_visibility",
  TransferProjectOwners = "transfer_project_owners",
  DuplicateProject = "duplicate_project",
  // ExportCodes = "export_codes",
  PreviewProject = "preview_project",
  PublishProject = "publish_project",
  DownloadSourceCodeOfProject = "download_source_code_of_project",

  // DesignOps
  ManageFonts = "manage_fonts",
  ManageColors = "manage_colors",
  ManageSizesSpaces = "manage_sizes_spaces",

  // DevOps
  // ViewConfigurationSettings = "view_settings",
  CreateConfiguration = "create_configuration",
  EditConfiguration = "edit_configuration",
  ManageConfigurations = "manage_configurations",

  // Component Designer
  CreateComponent = "create_component",
  EditComponent = "edit_component",
  DeleteComponent = "delete_component",
  AddEditStyles = "add_edit_styles",

  // not implemented
  CreateComponentSet = "create_component_set",
  CreateComponentGroup = "create_component_group",
  EditComponentSet = "edit_component_set",
  EditComponentGroup = "edit_component_group",
  AddComponentAction = "add_component_action",
  ViewComponentGroup = "view_component_group",
  DeleteComponentGroup = "delete_component_group",
  ExportComponents = "export_components",
  DeleteComponentSet = "delete_component_set",
  ImportExcelComponents = "import_excel_components",
  EditCustomComponents = "edit_custom_components",

  // Component Developer
  EditComponentAction = "edit_component_action",
  DeleteComponentAction = "delete_component_action",
  BindDataToComponent = "bind_data_to_component",
  AddEditSystemActions = "add_edit_system_component_action",

  // Screen Management
  // ViewScreen = "view_screen",
  EditScreen = "edit_screen",
  CreateScreen = "create_screen",
  DeleteScreen = "delete_screen",
  SaveScreen = "save_screen",
  ManageScreens = "manage_screens",
  EditScreenDesigns = "edit_screen_designs",
  // DeleteScreenTemplate = "delete_screen_template",
  // ShareScreen = "share_screen",
  // CreateTemplate = "create_template",
  // ViewScreenTemplates = "view_screen_templates",

  // AccessAllProjects = "access_all_projects",
  // ViewLogs = "view_logs",

  // Datasource Management
  ManageSystemActions = "manage_system_actions",
  ManageDatasource = "manage_datasource",
  ManageDataTable = "manage_data_table",
  ManageCustomActions = "manage_custom_actions",

  // Workflow Management
  ManageWorkflow = "manage_workflow",

  // Email Management
  ManageEmailDesigns = "manage_email_designs",
  ManageEmailParameters = "manage_email_parameters",

  // Report Management
  ManageReportDesigns = "manage_report_designs",
  ManageReportDesignsActions = "manage_report_designs_actions",

  // Scheduled Jobs Management
  ManageScheduledJobsDescriptions = "manage_scheduled_jobs_descriptions",
  ManageScheduledJobsActions = "manage_scheduled_jobs_actions",

  // API Management
  ManageAPI = "manage_api",

  // Ticket Management
  CreateNewTicket = "create_new_ticket",
  ManageAllTickets = "manage_all_tickets",
  ManageTickets = "manage_tickets"
}
